import { render, staticRenderFns } from "./BusinessTaxRates.vue?vue&type=template&id=5eb4d0d1"
import script from "./BusinessTaxRates.vue?vue&type=script&lang=js"
export * from "./BusinessTaxRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports